import { render } from "./ViewCommentModal.vue?vue&type=template&id=738d3ac4"
import script from "./ViewCommentModal.vue?vue&type=script&lang=js"
export * from "./ViewCommentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__